import React, { useState, useEffect } from 'react';
import MileStone from './MileStone';
import { Grid,Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from '../../adminStyles';


const MileStoneList = props => {
  const { negativeBtn, approveBtn } = useStyles();
  const {data}=props;
  const renderRecords=()=>{
    return data.map((rec,i)=>{
      return (
      <>
        <Grid item xs={8}>
          <MileStone data={{...rec}} onChange={(e)=>{
            props.onChangeText(i,e);
          }} />
        </Grid>
        <Grid item xs={4} container justify='flex-start' >
          {i===0?
          <>
           <Button  type='button'
            variant='raised'
            color='primary'
            className={negativeBtn} onClick={()=>{
            props.delMileStone(i);
          }}>Delete</Button>
          <Button className={approveBtn} variant='raised' color='primary' onClick={()=>{
            props.addMileStone();
          }}>Add</Button>
          </>:
          <Button  type='button'
            variant='raised'
            color='primary'
            className={negativeBtn} onClick={()=>{
            props.delMileStone(i);
          }}>Delete</Button>}
        </Grid>
      </>)  
    })
  }

  return(
    <Grid container direction="row" justify="flex-start" spacing={2}>
      {
        renderRecords()
      }
     </Grid>)
  }
  export default MileStoneList